export class SharedResource {
  resourceType: ResourceType;
  name: string;
  sharedResourceUuid: string;
  tenantOwnerUuid: string;
  organizationOwnerUuid: string;
  application: string;
  sharedDate: number;
  sharedVia: string;
  sharedByUser: string;
  sharedByUserUuid: string;
  catalogInfo: Map<string, string>;

  constructor(resourceType: ResourceType, name: string, sharedResourceUuid: string, tenantOwnerUuid: string, organizationOwnerUuid: string) {
    this.resourceType = resourceType;
    this.name = name;
    this.sharedResourceUuid = sharedResourceUuid;
    this.tenantOwnerUuid = tenantOwnerUuid;
    this.organizationOwnerUuid = organizationOwnerUuid;
  }
}

export type ResourceType = 'DEVICE' | 'ASSET';
